// Verified unavailable DZI sources; hide in lists and search until assets are restored.
export const unavailableViewerIds = new Set(['6553da86ac6b0fb8af9b89da','6570505eee60632f8bd7b0fa','65aa3685f32ad108f91a0e06','65aa36b5f32ad108f91a0e07']);
const drafts = new Set(['6666', 'полное название', 'тест', 'альб']);
export function isPublicTool(item) {
  return item && !unavailableViewerIds.has(item._id) && item.is_published !== false && !['draft', 'archived'].includes(item.status) && !drafts.has(String(item.name || '').trim().toLowerCase());
}
export function publicTools(items) { return Array.isArray(items) ? items.filter(isPublicTool) : []; }
